__turbopack_context__.v({
  "icon": "ButtonIcon-module__2EDr6W__icon",
});
